import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';

import { TypographyModule } from '@zwiloo/frontend/typography/typography.module';
import { SharedModule } from '@zwiloo/frontend/shared/shared.module';
import { CancelComponent } from './cancel.component';

@NgModule({
  declarations: [CancelComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TypographyModule,
  ],
})
export class CancelModule {}
